module.exports = {
      id: "fb-blue-usage",
      viewBox: "0 0 28 27.83",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#fb-blue",
      toString: function () {
        return this.url;
      }
    }